import * as React from "react";
import { OI } from "../onam/mark";
import { FEATURES } from "../onam/features";

type Props = React.SVGProps<SVGSVGElement> & { title?: string };

function BaseMetadataIcon({ title, ...props }: Props) {
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role="img"
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M20.5 12V5.749C20.5001 5.67006 20.4845 5.59189 20.4543 5.51896C20.4241 5.44603 20.3798 5.37978 20.324 5.324L17.176 2.176C17.0636 2.06345 16.9111 2.00014 16.752 2H5.1C4.94087 2 4.78826 2.06321 4.67574 2.17574C4.56321 2.28826 4.5 2.44087 4.5 2.6V21.4C4.5 21.5591 4.56321 21.7117 4.67574 21.8243C4.78826 21.9368 4.94087 22 5.1 22H11.5M8.5 10H16.5M8.5 6H12.5M8.5 14H11.5M21 20.5L22.5 22"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 2V5.4C16.5 5.55913 16.5632 5.71174 16.6757 5.82426C16.7883 5.93679 16.9409 6 17.1 6H20.5M15.5 18C15.5 18.7956 15.8161 19.5587 16.3787 20.1213C16.9413 20.6839 17.7044 21 18.5 21C19.2956 21 20.0587 20.6839 20.6213 20.1213C21.1839 19.5587 21.5 18.7956 21.5 18C21.5 17.2044 21.1839 16.4413 20.6213 15.8787C20.0587 15.3161 19.2956 15 18.5 15C17.7044 15 16.9413 15.3161 16.3787 15.8787C15.8161 16.4413 15.5 17.2044 15.5 18Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "meta" glyph instead (onam/mark.tsx). */
const MetadataIconSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="meta" size={props.size || 18} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseMetadataIcon {...props} />
  );
export default MetadataIconSkin;
